module.exports = __webpack_public_path__ + "static/media/upload-ready.2ad842a1.png";